var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.37492 7.575C4.13992 7.81 4.13992 8.19 4.37492 8.4225L9.17492 13.225C9.40992 13.46 9.78992 13.46 10.0224 13.225C10.2549 12.99 10.2574 12.61 10.0224 12.3775L5.64742 8.0025L10.0249 3.625C10.2599 3.39 10.2599 3.01 10.0249 2.7775C9.78992 2.545 9.40992 2.5425 9.17742 2.7775L4.37492 7.575Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "eb7f62edede1d186a8b84fced7d62b70.svg";